import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp } from 'lucide-react';
import { LEVELS } from '../data/gameData';

const XPBar = ({ currentXP, level, completedLevels = 0 }) => {
  // Calculate overall game progress (out of 19 levels)
  const totalLevels = LEVELS.length;
  const progress = Math.min((completedLevels / totalLevels) * 100, 100);

  return (
    <div className="w-full" data-testid="xp-bar">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-primary" />
          <span className="text-sm font-heading font-bold text-text-primary">Progreso del Juego</span>
        </div>
        <span className="text-xs text-text-secondary">
          {completedLevels} / {totalLevels} Niveles
        </span>
      </div>

      <div className="relative h-3 bg-background-subtle rounded-full overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 1, ease: 'easeOut' }}
          className="absolute top-0 left-0 h-full bg-gradient-to-r from-primary to-secondary rounded-full"
          style={{ boxShadow: '0 0 10px rgba(255, 107, 107, 0.5)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse" />
      </div>
    </div>
  );
};

export default XPBar;